export const delimiter = '₿';
export const anchorId = 'plat_anchor';
